import {
  DeliveriesModeFilter,
  DeliveriesProductFilter,
  DeliveriesSalesTermsFilter,
  DeliveriesShipToFilter,
  Filter,
  ShipDateFilter,
} from "components/Filters";
import { DeliveriesCreateDateFilter } from "components/Filters/Deliveries/DeliveriesCreateDateFilter";

const deliveriesFilters: Filter[] = [
  { key: "product", component: DeliveriesProductFilter },
  { key: "createDate", component: DeliveriesCreateDateFilter },
  { key: "shipDate", component: ShipDateFilter },
  { key: "shipTo", component: DeliveriesShipToFilter },
  { key: "mode", component: DeliveriesModeFilter },
  { key: "salesTerms", component: DeliveriesSalesTermsFilter },
];

export default deliveriesFilters;
